/*
 * @Author: Teemo Ding
 * @Date: 2021-12-24 10:19:46
 * @LastEditTime: 2022-01-07 09:35:32
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Order/SubscriptionBuy/SubscriptionBuyEdit/RecurringProducts/index.tsx
 */
import { useI18n } from '@/src/hooks/useRouterChange';
import { i18nGet } from '@/src/tools/tools';
import { Form } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { SectionWrapper } from 'src/components/Layouts';
import ProductItemsTable from '../../../Components/ProductsItems/ProductItemsTable';
import css from './css.module.less';

const RecurringProducts = ({ form, currency, nonOperational }) => {
  const i18n = useI18n();
  const getI18n = (str) => {
    return i18nGet(i18n, str);
  };
  return (
    <SectionWrapper
      title={getI18n(
        'subscriptionBuy.subscriptionBuy.subscriptionBuyEdit_RecurringProducts_title',
      )}
      containerClassName={css.section}
      titleClassName={css.sectionTitle}>
      <Form.Item
        noStyle
        shouldUpdate={(p, c) => {
          const cC = get(c, 'salesChannel.uuid');
          const pC = get(p, 'salesChannel.uuid');
          return cC !== pC;
        }}>
        {({ getFieldValue }: any) => (
          <Form.Item name='recurringProducts' initialValue={[]} noStyle>
            <ProductItemsTable
              nonOperational={nonOperational}
              currency={currency}
            />
          </Form.Item>
        )}
      </Form.Item>
    </SectionWrapper>
  );
};

export default RecurringProducts;
